import { Box } from '@mui/material'
import { Permission } from '@storage/app/models'
import { AddEntityButton } from '@storage/components/AddEntityButton'
import { useStores } from '@storage/hooks/use-stores.hook'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { PiersList } from '../components/piers-list'
import { BerthsFeatureStore } from '../stores'

interface Props {
  featureStore: BerthsFeatureStore
}

export const PiersListContainer = observer(
  ({ featureStore: { piersList, piersDialog, deleteDialog } }: Props) => {
    const { pierStore, authStore } = useStores()
    const { t } = useTranslate()

    const handleEditItem = (id: string) => {
      piersDialog.toggle(id)
    }

    const handleDeleteItem = async () => {
      if (!deleteDialog.id) return

      await pierStore.delete(deleteDialog.id)
      deleteDialog.close()
    }

    return (
      <Box>
        <PiersList
          items={piersList.filteredPiers}
          canWrite={authStore.hasPermission(Permission.WritePiers)}
          onEditItem={handleEditItem}
          onDeleteItem={id => deleteDialog.open(id)}
        />
        {authStore.hasPermission(Permission.WritePiers) && (
          <AddEntityButton onAddEntity={() => piersDialog.toggle()} />
        )}

        <ConfirmationDialog
          open={deleteDialog.isOpen}
          title={t('deletePierQuestion', 'Delete pier?')}
          message={t('confirmPierDelete', 'All berths on this pier will be removed as well.')}
          primaryActionText={t('yesDelete', 'Yes, delete')}
          closeLabel={t('cancelPierDeleting', 'No, keep pier')}
          onClose={deleteDialog.close}
          onConfirm={handleDeleteItem}
        />
      </Box>
    )
  },
)
